import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class VerifyDonationService {

  constructor(private http: HttpClient) { }

  async verify(receipt_id, receipt_date) {
    try {
      let response = await this.http
        .get(`${appApiResources.verifyDonation}?receipt_id=${receipt_id}&receipt_date=${receipt_date}`)
        // .get(`http://office.ezekiahfrancis.in/verifydownloadreceipt?receipt_id=${receipt_id}&receipt_date=${receipt_date}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}
